import React from "react";
import { Target, Eye } from "lucide-react";

export const MisionVision = () => (
    <section
        id="mision"
        className="bg-white py-20 sm:py-24"
        data-testid="mision-vision-section"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-2xl mx-auto mb-14">
                <span
                    className="text-xs font-semibold uppercase tracking-[0.22em]"
                    style={{ color: "var(--lf-green-dark)" }}
                >
                    Propósito institucional
                </span>
                <h2
                    className="mt-3 text-3xl sm:text-4xl font-bold lf-text-blue leading-tight"
                    data-testid="mision-vision-heading"
                >
                    ¿Por qué existimos y hacia dónde vamos?
                </h2>
                <div className="flex justify-center mt-5">
                    <div className="lf-gold-divider" />
                </div>
            </div>

            <div className="grid gap-8 md:grid-cols-2">
                <article
                    className="lf-card p-8 sm:p-10 shadow-md"
                    data-testid="mision-card"
                >
                    <div className="flex items-center gap-4 mb-6">
                        <div className="lf-icon-chip">
                            <Target size={26} strokeWidth={2} />
                        </div>
                        <div>
                            <span className="text-[11px] font-semibold uppercase tracking-[0.2em] lf-text-mute">
                                Nuestro compromiso
                            </span>
                            <h3
                                className="text-2xl font-bold lf-text-blue leading-tight"
                                data-testid="mision-title"
                            >
                                Misión
                            </h3>
                        </div>
                    </div>
                    <p
                        className="text-slate-600 leading-relaxed text-[15px]"
                        data-testid="mision-description"
                    >
                        Ser el instituto regulador en todo el territorio del
                        estado Falcón sobre la explotación, organización,
                        administración, prestación, control, supervisión y
                        vigilancia de la actividad de juegos de lotería en sus
                        diversas modalidades, permitiendo la promoción,
                        financiamiento y ejecución de programas sociales
                        dirigidos a personas y sectores en condiciones
                        vulnerables del estado.
                    </p>
                </article>

                <article
                    className="lf-card p-8 sm:p-10 shadow-md"
                    data-testid="vision-card"
                >
                    <div className="flex items-center gap-4 mb-6">
                        <div className="lf-icon-chip">
                            <Eye size={26} strokeWidth={2} />
                        </div>
                        <div>
                            <span className="text-[11px] font-semibold uppercase tracking-[0.2em] lf-text-mute">
                                Nuestra proyección
                            </span>
                            <h3
                                className="text-2xl font-bold lf-text-blue leading-tight"
                                data-testid="vision-title"
                            >
                                Visión
                            </h3>
                        </div>
                    </div>
                    <p
                        className="text-slate-600 leading-relaxed text-[15px]"
                        data-testid="vision-description"
                    >
                        Posicionarnos como institución líder y eficiente en el
                        manejo financiero de los recursos provenientes de los
                        juegos de azar, con tecnología de punta y altos
                        estándares de transparencia.
                    </p>
                </article>
            </div>
        </div>
    </section>
);
